import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);

  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              热门爆料
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              最受关注的51cg黑料深度报道
            </p>
          </div>
          <Link
            to="/category/zuixin-baoliao"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full">
                    热门
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span>{article.publishedAt}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors font-heading leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-1.5 mt-4">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-md"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/zuixin-baoliao"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}